import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=18522fea&"
import script from "./IconPlus.vue?vue&type=script&lang=js&"
export * from "./IconPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ebenhafkamp/Documents/Projects/tacpro/src/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18522fea')) {
      api.createRecord('18522fea', component.options)
    } else {
      api.reload('18522fea', component.options)
    }
    module.hot.accept("./IconPlus.vue?vue&type=template&id=18522fea&", function () {
      api.rerender('18522fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/icons/IconPlus.vue"
export default component.exports